<template>
  <div>
    <el-dialog
      title="创单"
      center
      :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="onClose"
      width="520px"
    >
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-form-item label="类型：">
          <el-radio-group v-model="form.byType">
            <el-radio :label="1">内部人员</el-radio>
            <el-radio :label="2">场外交易</el-radio>
            <el-radio :label="3">赠送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="UID：">
          <el-input
            v-model="value.uid"
            :disabled="true"
            style="width: 195px"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input
            v-model="value.name"
            :disabled="true"
            style="width: 195px"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品：">
          <shop-item
            :availableAttachments="availableShopItems"
            v-model="form.productId"
          ></shop-item>
        </el-form-item>
        <el-form-item label="数量：">
          <el-input
            v-model="form.productNumber"
            style="width: 195px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            style="width: 195px"
            type="textarea"
            rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-left: 20px; margin-top: 30px">
        注意事项：
        <li style="font-size: x-small">
          “内部人员”类型：通常是向研发及运营人员发放付费道具，用于游戏体验或测试
        </li>
        <li style="font-size: x-small">
          “场外交易”类型：向通过场外完成交易（例如玩家无法使用游戏内的支付渠道，进而使用了游戏外的某种交易渠道）的玩家发放付费道具
        </li>
        <li style="font-size: x-small">
          “赠送”类型：用于激励或者奖励部分玩家（比如换到了新区的大R玩家）
        </li>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "CompensationOrderDialog";

import ShopItem from "../components/ShopItem";

export default {
  data() {
    return {
      form: {
        byType: 1,
        productId: null,
        productNumber: 1,
        remark: "",
      },
      value: {},
      availableShopItems: [],
    };
  },
  components: {
    ShopItem,
  },

  created() {
    this.loadAvailableItems();
    this.value = dialogutil.getData(DialogName);
  },
  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.create();
    },

    /**
     * 创单
     */
    async create() {
      // 校验输入
      {
        if (!this.form.productId) {
          this.$message.info("请选择要发放的商品");
          return;
        }

        let productNumber = parseInt(this.form.productNumber);
        if (
          String(productNumber) != String(this.form.productNumber) ||
          productNumber <= 0
        ) {
          this.$message.info("请正确输入商品数量");
          return;
        }
      }

      try {
        // 弹确认框
        await this.$confirm(
          `确定向玩家“${this.value.name}”发放如下付费商品吗：
          <br/>
              - 商品：${this.getShopNameById(this.form.productId)}
          <br/>
          - 商品ID：${this.form.productId}
          <br/>
          - <span style="color:red">数量：${this.form.productNumber}</span>
          `,
          {
            dangerouslyUseHTMLString: true,
          }
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/compensationOrder`,
            {
              uid: this.value.uid,
              productIds: [this.form.productId],
              productNumber: this.form.productNumber,
              type: this.form.byType,
              remark: this.form.remark,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "发放成功。玩家重新登录游戏后即会生效。",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {
        console.log("error=>", e);
      }
    },

    /**
     * 查询可用道具集合
     */
    async loadAvailableItems() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: true,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      if (resData.data.categories.length > 0) {
        for (let category of resData.data.categories) {
          if (category.name == "支付项") {
            for (let e of category.entries) {
              this.availableShopItems.push({
                label: e.name,
                value: e.id,
                children: null,
              });
            }
          }
        }
      }
    },
    /**
     * 通过支付项id获取商品名称
     * @param {*} id
     */
    getShopNameById(id) {
      for (let item of this.availableShopItems) {
        if (item.value == id) {
          return item.label;
        }
      }
      return "";
    },
    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>